import { REGEX_TYPE_DATA } from '@app/shared/constants/search.constants';
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export function createSmartSearchValidator(onlyType?: string[]): ValidatorFn {
  const isValidSearch = (textSearch: string): boolean => {
    const regexps = REGEX_TYPE_DATA;
    let isValidSearch = false;
    if (textSearch != '') {
      regexps.forEach((regexp: RegExp, key: string) => {
        if (onlyType && !onlyType.includes(key)) {
          return;
        }
        if (regexp.test(textSearch)) {
          isValidSearch = true;
          return;
        }
      });
    }
    return isValidSearch;
  }

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    return !isValidSearch(value) ? { invalidSearch: true } : null;
  };
}
